import React from 'react';

import Agrupation from './agrupation';
import CartCell from '../../Cell/CartKoedia';

import { getSystemSettings } from '../../../utils/SettingsRetriever';

export default function Products(props){

    let packageUpselling = false;
    if(getSystemSettings().app.cart && getSystemSettings().app.cart.packageUpselling){
        packageUpselling = getSystemSettings().app.cart.packageUpselling;
    }

    function removeItemModalOpen(item, value){
        props.deleteItem(item, value)
    }

    function removePackageModalOpen(Package, value){
        props.removePackage(Package, value)
    }

    function getBundle(itemId){
        props.getBundle(itemId);
    }

    function getPackage(PackageId, arrivalDate, departureDate, adults, children, ComponentId ){
        props.getPackage(PackageId, arrivalDate, departureDate, adults, children, ComponentId );
    }

    function getPackageElements(agrupation){
        let arrayComponents = [];
        let componentData = {
            arrival: undefined,
            departure: undefined,
            adults: undefined,
            children: undefined,
            code: ''
        };

        if(props.selectedPackage.PackageCode !== '') componentData.code = props.selectedPackage.PackageCode;
        props.selectedPackage.Components.forEach((component) => {
            let addComponent = true
            agrupation.items.forEach((item, index) => {
                if (item.PackageComponentId === component.ComponentId){
                    addComponent = false;
                    if (item.SuperCategoryId === 1){
                        componentData.arrival = item.ArrivalDateDt;
                        componentData.departure = item.DepartureDateDt;
                    }
                    componentData.adults = item.AdultCount;
                    componentData.children = item.ChildCount;
                }

                if(componentData.arrival === undefined && index === 0){
                    componentData.arrival = item.ArrivalDateDt;
                    componentData.departure = item.DepartureDateDt;
                    componentData.adults = item.AdultCount;
                    componentData.children = item.ChildCount;
                }
            });

            if (addComponent === true){
                arrayComponents.push(
                    <div onClick={()=>getPackage(component, componentData)} className="bundle item">
                        [ + ] { component.ComponentName && component.ComponentName !== '' ? component.ComponentName : component.CategoryName }
                    </div>
                );
            }
        });

        return (
            <React.Fragment>
            {
                arrayComponents.length > 0
                ?
                <React.Fragment>
                    <div className="addMore">
                        Add More and Save
                    </div>
                    { arrayComponents }
                </React.Fragment>
                :
                null
            }
            </React.Fragment>
        );
    }

    return (
        <div className="products">
            {props.cart.map((agrupation, idx) => {
                return(<Agrupation readOnly={props.readOnly} getBundle={getBundle.bind(this)} key={idx} deleteItem={removeItemModalOpen.bind(this)} removePackage={removePackageModalOpen.bind(this)} agrupation={agrupation} idx={idx}/>)
            })
            }
            {props.elibertyCart && props.elibertyCart.length > 0 && props.elibertyCart.map((product, index) => {
                return (
                        <div className="agrupation">
                            <div className="header">
                                {product.type}
                            </div>
                            <CartCell key={index} index={index} item={product} />
                        </div>
                    )
                })
            }
            {
                props.cart.map(agrupation => {
                   return agrupation.supercategoryid === 0 && Object.keys(props.selectedPackage).length !== 0 && packageUpselling
                    ?
                    getPackageElements(agrupation)
                    :
                    null
                })
            }
        </div>
    )
}